<template>
  <sea-page title="Lista CU" header="Elenco CU">
    <sea-page-content
      :fetchList="fetchList"
      :resetList="resetList"
      searchPanel
      searchType="anno"
    >
      <template v-slot:table="{ attrs }">
        <v-data-table
          v-bind="attrs"
          :items="items"
          :headers="headers"
          disable-sort
          dense
          height="calc(100vh - 255px)"
          item-key="id"
          :expanded="expanded"
          @click:row="clicked"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row
                no-gutters
                class="text-center justify-center align-center my-2"
              >
                <v-col cols="6"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold">Reddito lordo</span></v-card
                  ></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Giorni detrazione</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile>{{
                    item.redditoLordo | currencyFormat
                  }}</v-card></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile>{{
                    item.giorniDetrazione
                  }}</v-card></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Addizionali Irpef</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Ritenute Irpef</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile>{{
                    item.addizionaliIrpef | currencyFormat
                  }}</v-card></v-col
                >
                <v-col cols="6"
                  ><v-card outlined flat tile>{{
                    item.ritenuteIrpef | currencyFormat
                  }}</v-card></v-col
                >
                <v-col cols="12"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Addizionale comunale</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="4"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Acconto {{ item.anno - 1 }}</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="4"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Saldo {{ item.anno - 1 }}</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="4"
                  ><v-card outlined flat tile
                    ><span class="font-weight-bold"
                      >Acconto {{ item.anno }}</span
                    ></v-card
                  ></v-col
                >
                <v-col cols="4"
                  ><v-card outlined flat tile>{{
                    item.accontoAnnoPrecedente | currencyFormat
                  }}</v-card></v-col
                >
                <v-col cols="4"
                  ><v-card outlined flat tile>{{
                    item.saldoAnnoPrecedente | currencyFormat
                  }}</v-card></v-col
                >
                <v-col cols="4"
                  ><v-card outlined flat tile>{{
                    item.accontoAnnoCorrente | currencyFormat
                  }}</v-card></v-col
                >
              </v-row>
            </td>
          </template>
          <template v-slot:item.statoLettura="{ item }">
            <stato-lettura :stato="item.statoLettura"></stato-lettura>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              elevation="2"
              rounded
              x-small
              @click.stop="clicked(item)"
              color="primary"
              class="mr-2"
            >
              Dettaglio
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              elevation="2"
              rounded
              x-small
              @click.stop="download(item)"
              color="primary"
            >
              Apri
              <v-icon right dark>mdi-cloud-download </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StatoLettura from "@/components/StatoLettura.vue";

const headers = [
  { text: "Anno", value: "anno", class: "head" },
  { text: "Tipologia", value: "descrizione", class: "head" },
  { text: "Letto", value: "statoLettura", class: "head" },
  { text: "", value: "actions", class: "head", align: "end" },
];

export default {
  components: { StatoLettura },
  data() {
    return {
      expanded: [],
      headers,
    };
  },
  methods: {
    ...mapActions({
      fetchList: "cud/fetchCuds",
      resetList: "cud/resetData",
      download: "cud/downloadCud",
    }),
    clicked(value) {
      const index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded.length = 0;
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },
  },
  computed: {
    ...mapGetters({
      items: "cud/data",
    }),
  },
};
</script>

<style>
</style>
